import { Stack } from "@mui/system";
import { Typography } from "@mui/material";

export const NewCampaignBlock = () => {
  return (
    <Stack
      alignItems={"center"}
      justifyContent={"center"}
      padding="4px 8px"
      sx={{
        justifyContent: "center",
        alignItems: "center",
        padding: "4px 8px",
        borderRadius: "4px",
        backgroundColor: "#52BE80",
      }}
    >
      <Typography sx={{ fontSize: "14px", fontWeight: 500, color: "white" }}>
        New
      </Typography>
    </Stack>
  );
};
